import { useEffect, useId, useRef } from 'react';
import { cellCoordinate, formatCents, listMonths, makeCell, parseBRL } from './money';

// inputValues belongs to the parent so uncommitted text survives paging/source changes.
export default function PlanGrid({ scopes = [], cells = [], period, fromMonth, onPageChange, canEdit = false, onChange, inputValues = {}, onInputValuesChange, onValidationChange }) {
  const id = useId();
  const validationCallback = useRef(onValidationChange);
  validationCallback.current = onValidationChange;
  const errors = {};
  Object.entries(inputValues).forEach(([key, value]) => {
    try { parseBRL(value); } catch (error) { errors[key] = error.message; }
  });
  try { listMonths(period); } catch (error) { errors.period = error.message; }
  const serializedErrors = JSON.stringify(errors);
  useEffect(() => { validationCallback.current?.({ valid: serializedErrors === '{}', errors: JSON.parse(serializedErrors) }); }, [serializedErrors]);
  let allMonths;
  try { allMonths = listMonths(period); } catch (error) { return <p role="alert">{error.message}</p>; }
  if (scopes.length > 100) return <p role="alert">O planejamento aceita até 100 grupos de custos.</p>;
  const start = Math.max(0, allMonths.indexOf(fromMonth));
  const months = allMonths.slice(start, start + 12);
  const byCoordinate = new Map(cells.map(cell => [cellCoordinate(cell.costScopeId, cell.budgetMonth), cell]));
  return <section className="governance-subsection" aria-label="Valores mensais do planejamento">
    <nav aria-label="Meses do planejamento">
      <button type="button" disabled={start === 0} onClick={() => onPageChange?.(allMonths[Math.max(0, start - 12)])}>12 meses anteriores</button>
      <span>{months[0]} a {months[months.length - 1]}</span>
      <button type="button" disabled={start + 12 >= allMonths.length} onClick={() => onPageChange?.(allMonths[start + 12])}>Próximos 12 meses</button>
    </nav>
    <div className="director-table-scroll">
      <table className="director-table"><caption>Orçamento declarado em reais. Vazio significa não informado; zero é um valor explícito.</caption>
        <thead><tr><th scope="col">Grupo de custos</th>{months.map(month => <th scope="col" key={month}>{month}</th>)}</tr></thead>
        <tbody>{scopes.map(scope => <tr key={scope.costScopeId}><th scope="row">{scope.label || scope.costScopeId}</th>{months.map(month => {
          const key = cellCoordinate(scope.costScopeId, month);
          const existing = byCoordinate.get(key);
          let text, error;
          try { text = inputValues[key] ?? formatCents(existing?.plannedCents); parseBRL(text); } catch (failure) { text = inputValues[key] ?? ''; error = failure.message; }
          const inside = !scope.period || (month >= scope.period.startMonth && month <= scope.period.endMonth);
          const errorId = `${id}-${encodeURIComponent(key)}-error`;
          return <td key={month}><input type="text" inputMode="decimal" maxLength={100} autoComplete="off" aria-label={`${scope.label || scope.costScopeId} — ${month} (R$)`} aria-invalid={Boolean(error)} aria-describedby={error ? errorId : undefined} disabled={!canEdit || !inside} value={text}
            onChange={event => { if (canEdit && inside) onInputValuesChange?.({ ...inputValues, [key]: event.target.value }); }}
            onBlur={() => {
              if (!canEdit || !inside || error || inputValues[key] === undefined) return;
              onChange?.({ upsertCells: [makeCell(cells, scope.costScopeId, month, parseBRL(text))], removeCellIds: [] });
            }} />{error && <p role="alert" id={errorId}>{error}</p>}</td>;
        })}</tr>)}</tbody>
      </table>
    </div>
  </section>;
}
